import { DeprecatedMultiSelectInput } from "common/form/inputs/multi_select";
import { DeprecatedFieldWrapper } from "common/form/enhancers/redux_form_field_wrapper";

/** @deprecated - please use components in common/core/form */
export const DeprecatedMultiSelectField = DeprecatedFieldWrapper(DeprecatedMultiSelectInput);
